<template>
  <div id="email" class="error-modal" @click.esc="close">
    <div class="error-modal-body">
      <div class="error-error text-center">
        <div class="choose-title">
          Та картын дугаар болон утасны дугаар нягтлана уу
        </div>
        <div class="choose-body">
          <div class="choose-body-item">
            <input
              type="radio"
              id="Cardnumber"
              value="Cardnumber"
              v-model="selected"
            />
            <label for="Cardnumber"
              >Картын дугаараар илгээх бол энийг идэвхижүүлнэ үү</label
            >
          </div>
          <div class="choose-body-item">
            <input
              type="radio"
              id="Idphone"
              value="Idphone"
              v-model="selected"
            />
            <label for="Idphone"
              >Утасны дугаараар илгээх бол энийг идэвхижүүлнэ үү</label
            >
          </div>
        </div>

        <div class="choose-footer">
          <button class="confirm" @click="confirm()">Сонголтоо батлах</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import confirmInfoVue from "./confirmInfo.vue";
export default {
  props: ["SearchType", "isCardnumber"],
  data() {
    return {
      Cardnumber: false,
      Idphone: false,
      layer: {},
      selected: "",
    };
  },
  methods: {
    close() {
      this.$emit("hideSuccessMessage");
    },
    confirm() {
      if (this.selected !== null) {
        this.$emit("onChooseOverlap", { SearchType: this.selected });
      } else {
        alert("Та заавал нэгийг нь сонгоно уу");
      }
    },
  },
};
</script>

<style scoped>
.choose-title {
  font-size: 14px;
  padding: 10px 0;
  color: #1660ab;
  text-transform: uppercase;
}
.choose-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.choose-body .choose-body-item {
  flex-direction: row;
  display: flex;
  padding: 5px 30px;
}
.choose-body-item label {
  line-height: 1em;
  margin-left: 5px;
  font-weight: 400;
}

.choose-footer button {
  color: #fff;
  background: #1660ab;
  border: 1px solid #1660ab;
}
.error-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.error-modal-body {
  position: absolute;
  top: 20%;
  width: 465px;
  height: 180px;
  border: 1px solid #1660ab;
  border-radius: 5px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.error-modal-body .error-error {
  margin-top: 30px !important;
  font-size: 13px;
  width: 306px;

  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 20%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 10%;
    width: 80%;
    height: 210px;
  }
  .error-modal-body .error-img {
    left: 130px;
  }
}
</style>
